import { render, staticRenderFns } from "./manage-admission.html?vue&type=template&id=3e778ac8&scoped=true&external"
import script from "./manage-admission.js?vue&type=script&lang=js&external"
export * from "./manage-admission.js?vue&type=script&lang=js&external"
import style0 from "./manage-admission.scss?vue&type=style&index=0&id=3e778ac8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e778ac8",
  null
  
)

export default component.exports